import React from "react";
import { Modal } from "react-bootstrap";
import { ChevronRightIcon } from "../../StrategyCanvasHelpers";
import "./ReviewInfoModal.scss";

const STEPS = [
  "Go into review mode and work through each block one at a time",
  "Accept the block, or mark it for discussion",
  "Add a comment on anything you want to talk through",
  "Optionally, leave comments at the section level or on the canvas overall",
  "Every block you mark 'To discuss' and every comment you leave goes on the agenda for your live review with the CEO and their leadership team",
];

// Figma node 33288-145187 - the info popup opened from the "i" icon in the
// Review screen header, explaining Canvas mode vs Review mode.
const ReviewInfoModal = ({ onClose }) => (
  <Modal
    show
    onHide={onClose}
    centered
    dialogClassName="rim-dialog"
    contentClassName="rim-content"
  >
    <Modal.Body className="rim-body">
      <h3 className="rim-title">Start strategy canvas review</h3>
      <p className="rim-subtitle">
        The CEO has sent you their draft Strategy Canvas. Here&apos;s how to work through it.
      </p>
      <p className="rim-text">
        You&apos;ve got two modes to work with. <strong>Canvas mode and Review mode</strong>
      </p>
      <p className="rim-text">
        Canvas mode shows the full canvas laid out the way the CEO built it, and review mode
        is where you do the actual pass, block by block. This is your solo review before your
        live review with the CEO and their leadership team.
      </p>

      <ol className="rim-steps">
        {STEPS.map((step, index) => (
          <li key={index}>{step}</li>
        ))}
      </ol>

      <div className="rim-divider" />

      <div className="rim-footer">
        <button type="button" className="rim-ok-btn" onClick={onClose}>
          Got it
          <ChevronRightIcon />
        </button>
      </div>
    </Modal.Body>
  </Modal>
);

export default ReviewInfoModal;
